import React, { useEffect, useRef } from "react";

const Latex = ({ children }) => {
  const container = useRef(null);

  useEffect(() => {
    if (window.MathJax && container.current) {
      // 1. Clean content:
      let content = (children || "")
        .trim() // remove leading/trailing whitespace
        .replace(/(\n|\s)*$/, "") // remove trailing newlines and spaces
        .replace(/\n/g, "<br>"); // replace remaining newlines with <br>

      container.current.innerHTML = content;

      // 2. Typeset with MathJax
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, container.current]);
    }
  }, [children]);

  return <div ref={container} />;
};

export default Latex;
